export default __webpack_public_path__ + "static/media/58.63a6316d.svg";